import React from 'react';
import clsx from 'clsx';

export type ContainerProps = {
  children: React.ReactNode;
  max?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  bleed?: boolean;
  padX?: 'sm' | 'md' | 'lg' | 'xl';
};

export function Container({ children, max = 'xl', bleed = false, padX = 'md' }: ContainerProps) {
  const style: React.CSSProperties = {};
  if (!bleed) {
    style.paddingInlineStart = `calc(var(--pad-${padX}) + env(safe-area-inset-left))`;
    style.paddingInlineEnd = `calc(var(--pad-${padX}) + env(safe-area-inset-right))`;
  }
  const maxClass = bleed ? 'w-full' : `max-w-container-${max}`;
  return (
    <div className={clsx('mx-auto', maxClass)} style={style}>
      {children}
    </div>
  );
}
